import { IonContent, IonSpinner } from "@ionic/react";
import React, { useEffect, useRef } from "react";
import { keyExists } from "../common/commonFunctions";
import "./styles/ContentWithBackground.css";

const ContentWithBackground: React.FC<{
  isLoading?: boolean;
  disableBG?: boolean;
  refLocal?: any;
  id?: string;
}> = (props) => {
  const classBgCss = props.disableBG ? "" : "content-with-background";
  const ref = useRef(null);
  useEffect(() => {
    console.log("Ref for content ", ref, props);
    if (ref) {
      if (keyExists("refLocal", props)) {
        console.log("write to content ref");
        props.refLocal.current["content"] = ref;
      }
    }
  }, [ref]);
  return (
    <IonContent class={classBgCss} ref={ref} id={props.id ? props.id : ""}>
      {props.isLoading && (
        <div className="content-with-background-spinner-wpr">
          <IonSpinner
            name="circular"
            className="content-with-background-spinner"
          />
          <p className="content-with-background-text">Loading...</p>
        </div>
      )}
      {props.children}
    </IonContent>
  );
};

export default ContentWithBackground;
